"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconInputBase = exports.iconInputErrorStyles = exports.iconInputStyles = void 0;
var react_1 = __importStar(require("react"));
var Error_1 = require("../InputModules/Error");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var css_1 = require("@emotion/css");
var uuid_1 = require("uuid");
var helperFunctions_1 = require("../utils/helperFunctions");
var containerStyles = function (errorPlacement) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: ", ";\n  position: relative;\n"], ["\n  display: inline-flex;\n  flex-direction: ", ";\n  position: relative;\n"])), errorPlacement === 'right' ? 'row' : 'column'); };
var labelColor = function (isDisabled, selectedTheme) {
    if (selectedTheme === 'dark') {
        return isDisabled ? design_system_foundations_1.theme.color.neutral40 : design_system_foundations_1.theme.color.neutral10;
    }
    return isDisabled ? design_system_foundations_1.theme.color.neutral60 : design_system_foundations_1.theme.color.neutral100;
};
var labelStyles = function (hasLabel, isDisabled, font, selectedTheme) { return (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  display: inline-flex;\n  flex-flow: row;\n  align-items: center;\n  ", "\n  color: ", ";\n  cursor: ", ";\n  ", "\n"], ["\n  ", ";\n  display: inline-flex;\n  flex-flow: row;\n  align-items: center;\n  ", "\n  color: ", ";\n  cursor: ", ";\n  ", "\n"])), (0, design_system_foundations_1.expandFontTheme)((0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, font)), hasLabel &&
    "& span {\n      margin-right: 8px;\n    }", labelColor(isDisabled, selectedTheme), isDisabled ? "not-allowed;" : 'pointer;', selectedTheme === 'dark' && 'line-height: 1;'); };
var iconInputStyles = function (isDisabled) { return (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow: hidden;\n  opacity: 0;\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  right: 0px;\n  left: 0px;\n  white-space: nowrap;\n  cursor: ", ";\n"], ["\n  overflow: hidden;\n  opacity: 0;\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  right: 0px;\n  left: 0px;\n  white-space: nowrap;\n  cursor: ", ";\n"])), isDisabled ? "not-allowed;" : 'pointer;'); };
exports.iconInputStyles = iconInputStyles;
var iconInputErrorStyles = function (errorPlacement) { return (0, css_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-self: ", ";\n  ", "\n"], ["\n  align-self: ", ";\n  ", "\n"])), errorPlacement === 'right' ? 'center' : 'flex-start', errorPlacement === 'right' ? 'margin-left: 16px;' : 'margin-top: 8px;'); };
exports.iconInputErrorStyles = iconInputErrorStyles;
exports.IconInputBase = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var ariaLabel = _a["aria-label"], children = _a.children, className = _a.className, error = _a.error, _c = _a.errorPlacement, errorPlacement = _c === void 0 ? 'bottom' : _c, _d = _a.font, font = _d === void 0 ? 'body' : _d, id = _a.id, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e, label = _a.label, renderInput = _a.renderInput, style = _a.style, testId = _a.testId, _f = _a.useInlineError, useInlineError = _f === void 0 ? true : _f, rest = __rest(_a, ['aria-label', "children", "className", "error", "errorPlacement", "font", "id", "isDisabled", "label", "renderInput", "style", "testId", "useInlineError"]);
    (0, helperFunctions_1.validateInputLabelAccessibility)('IconInputBase', label, ariaLabel);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var uniqueId = (0, react_1.useMemo)(function () { return id !== null && id !== void 0 ? id : (0, uuid_1.v4)(); }, [id]);
    var renderError = error && useInlineError;
    return (react_1.default.createElement("div", { className: (0, css_1.cx)(containerStyles(errorPlacement), className), style: style, "data-testid": testId && "".concat(testId, "-container") },
        react_1.default.cloneElement(renderInput(), (_b = {},
            _b['data-testid'] = testId && "".concat(testId, "-input"),
            _b.id = uniqueId,
            _b['aria-label'] = ariaLabel,
            _b)),
        react_1.default.cloneElement(react_1.default.createElement("label", __assign({ "data-testid": testId, className: labelStyles(!!label, isDisabled, font, selectedTheme), htmlFor: uniqueId }, rest),
            children,
            label), { ref: ref }),
        renderError && (react_1.default.createElement("div", { className: (0, exports.iconInputErrorStyles)(errorPlacement) },
            react_1.default.createElement(Error_1.ErrorInput, { id: uniqueId, error: error, testId: testId })))));
});
exports.IconInputBase.displayName = 'IconInputBase';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
